import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { XIcon } from 'appSrc/components/UI';
import uuidv4 from 'uuid/v4';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class DLModal extends PureComponent {
    constructor( props ) {
        super( props );
        this.id = `dl-modal-${ uuidv4() }`;
    }
    componentDidMount() {
        if( this.props.visible ) {
            document.body.classList.add( this.id );
        }
    }
    componentWillUnmount() {
        document.body.classList.remove( this.id );
    }
    componentDidUpdate( prevProps ) {
        if( this.props.visible != prevProps.visible ) {
            if( this.props.visible ) {
                document.body.classList.add( this.id );
            }
            if( !this.props.visible ) {
                document.body.classList.remove( this.id );
            }
        }
    }
    render() {
        const className = `${ style.modalWindow } ${ this.props.className }`.trim();
        return (
            <div className={ style.modalOverlay } data-visible={ this.props.visible }>
                <div className={ style.closeOverlay } onClick={ this.props.closeHandler }></div>
                <div className={ className }>
                    <div className={ style.titleBar }>
                        <h3 className={ style.modalTitle }>{ this.props.title }</h3>
                        <div className={ style.closeIcon } onClick={ this.props.closeHandler }>
                            <XIcon size={ 24 } />
                        </div>
                    </div>
                    <div className={ style.modalContent + ' modal-content' }>
                        { this.props.visible && this.props.children }
                    </div>
                    { this.props.fetching &&
                        <LoadingOverlay />
                    }
                </div>
            </div>
        );
    }
}
DLModal.propTypes = {
    title: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
};
DLModal.defaultProps = {
    onSubmit: () => {},
    className: '',
    visible: true,
};

export default DLModal;
